import styled from "styled-components";

export const CetificateLandingContainerStyled = styled.div`
  padding: 24px 20px 40px 20px;
  .certificate_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .cl_preview_wrap {
      margin-bottom: 20px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      border-radius: 12px;
      overflow: hidden;
      .cl_preview {
        width: 100%;
        height: auto;
      }
    }
    .cl_hint {
      margin-top: 14px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      line-height: 1.5;
    }
    .cl_message_block {
      padding: 40px 0;
      text-align: center;
      .cl_title {
        margin-bottom: 10px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S21};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .cl_desc {
        margin-bottom: 24px;
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        line-height: 1.5;
      }
    }
    .cl_btn_wrap {
      width: 100%;
      margin-bottom: 12px;
      &.cl_btn_home {
        margin-top: 20px;
      }
    }
  }

  .certificate_canva {
    display: none;
  }
`;
